// After the capacity quick-edit modal saves, chain into the standard add-registration modal.
jQuery(function () {
  jQuery(document).on("new-action-modal:success", '[data-behaviour~="capacity-then-registration"]', function () {
    var $trigger = jQuery(this);
    var link = document.createElement("a");

    link.href = $trigger.data("continue-url");
    link.dataset.behaviour = "new-action-modal";
    link.dataset.title = $trigger.data("continue-title");
    link.dataset.modalModifierEscOut = "false";

    document.body.appendChild(link);
    link.click();
    link.remove();
  });
});
